export enum PopUpConfirmationType {
    DELETE = "delete",
    WARNING = "warning", 
    INFO = "info", 
    SUCCESS ="succes"
}
